<div class="border-primary-subtle mb-3 p-3">
    <h5>Hoe werkt de personeelsplanning?</h5>

    <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
        @for (item of items; track item.title) {
            <div class="col">
                <div class="d-inline-flex align-items-center gap-2 mb-2 fw-bold">
                    <i class="fas text-primary" [ngClass]="item.icon"></i>
                    {{ item.title }}
                </div>

                <p class="small" [innerHTML]="item.lines | joinBy: 'text' : '<br />'"></p>
            </div>
        }
    </div>
</div>
